import http from './http';

export async function getGridLogService(params) {
  const {
    page = 1,
    itemsPerPage = 10,
    sortBy = [],
    idorder = '',
    nivel = '',
    mensaje = '',
    fecha_desde = '',
    fecha_hasta = ''
  } = params || {}

  let query = `?page=${page}&limit=${itemsPerPage}`
  if (idorder) query += `&idorder=${encodeURIComponent(idorder)}`
  if (nivel) query += `&nivel=${encodeURIComponent(nivel)}`
  if (mensaje) query += `&mensaje=${encodeURIComponent(mensaje)}`
  if (fecha_desde) query += `&fecha_desde=${encodeURIComponent(fecha_desde)}`
  if (fecha_hasta) query += `&fecha_hasta=${encodeURIComponent(fecha_hasta)}`

  if (sortBy.length > 0) {
    query += `&sort=${sortBy[0].key}&order=${sortBy[0].order}`
  }

  try {
    const response = await http.get(`/admin/log/grid${query}`)
    return response.data
  } catch (error) {
    console.error('Error al obtener el listado de logs:', error)
    throw error
  }
}
